import Docs from '../pages/Docs';

const routes = [
    {
        path: "",
        component: Docs,
    },
]

export default routes;